<div [formGroup]="formGroup">
  <section>
    <div
      class="card mb-4"
      [ngClass]="
        submitted && formGroup.invalid
          ? 'border-danger border-2'
          : 'card-border-color-from-db'
      "
    >
      <div class="card-header card-header-color-from-db">
        {{
          'MONUMENT_CONSERVATION_GRANT_REQUEST.WORK_ESTIMATED_COSTS.TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <div class="row mb-4">
          <div class="col">
            <label class="mb-0" [attr.for]="controlName.TotalAmount">
              {{
                'MONUMENT_CONSERVATION_GRANT_REQUEST.TOTAL_AMOUNT' | translate
              }}
            </label>

            <input
              type="input"
              [name]="controlName.TotalAmount"
              [id]="controlName.TotalAmount"
              class="form-control form-control-sm required"
              [formControlName]="controlName.TotalAmount"
              (keypress)="validateFloatInput($event)"
            />

            @let totalAmountFormControlAlertShouldBeVisible =
              submitted && !isTotalAmountFormControlValid();
            @if (totalAmountFormControlAlertShouldBeVisible) {
              <div class="alert alert-danger mt-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>
        </div>

        <div class="p-4 border rounded mb-4">
          <div class="fs-3 mb-3">
            {{
              'MONUMENT_CONSERVATION_GRANT_REQUEST.TOTAL_AMOUNT_INCLUDES'
                | translate
            }}:
          </div>
          <div class="mb-4">
            <app-mcgr-costs-section
              [formGroup]="getMunicipalFundsFormGroup()"
              [submitted]="submitted"
              [idPrefix]="'municipal-funds-'"
              [sectionHeader]="
                'MONUMENT_CONSERVATION_GRANT_REQUEST.MUNICIPAL_FUNDS'
              "
            ></app-mcgr-costs-section>
          </div>
          <div class="mb-4">
            <app-mcgr-costs-section
              [formGroup]="getOwnFundsFormGroup()"
              [submitted]="submitted"
              [idPrefix]="'own-funds-'"
              [sectionHeader]="'MONUMENT_CONSERVATION_GRANT_REQUEST.OWN_FUNDS'"
            ></app-mcgr-costs-section>
          </div>
          <div class="mb-4">
            <app-mcgr-costs-section
              [formGroup]="getStateBudgetFundsFormGroup()"
              [submitted]="submitted"
              [idPrefix]="'state-budget-funds-'"
              [sectionHeader]="
                'MONUMENT_CONSERVATION_GRANT_REQUEST.STATE_BUDGET_FUNDS'
              "
            ></app-mcgr-costs-section>
          </div>
          <div class="mb-4">
            <app-mcgr-costs-section
              [formGroup]="getLocalGovernmentBudgetFundsFormGroup()"
              [submitted]="submitted"
              [idPrefix]="'local-government-budget-funds-'"
              [sectionHeader]="
                'MONUMENT_CONSERVATION_GRANT_REQUEST.LOCAL_GOVERNMENT_BUDGET_FUNDS'
              "
            ></app-mcgr-costs-section>
          </div>
          <app-mcgr-other-source-settlement-scope-form-array
            [formGroup]="formGroup"
            [submitted]="submitted"
          ></app-mcgr-other-source-settlement-scope-form-array>
        </div>
      </div>
    </div>
  </section>
</div>
